import Regex from "./Regex";
import Validators from "./Validators";

export default {
    Regex,
    Validators,
    googleMapsAPIKey: "AIzaSyAXN44K9ZhrSdFr-yJpkHIdEg1o0C_Sp6Q",
    recaptchaSiteKey: "6LcROwElAAAAAMLAe2AvXUzUMSdkAdeZG3a9zzjG",
};
